import React, { Component } from 'react'
// import PropTypes from 'prop-types'

export default class ReactNativeListItem extends Component {
  // static propTypes = {
  //   prop: PropTypes
  // }

  render() {
    return (
      <span>
        The dev ops that are necessary to launch both Android and IOS apps are immense, and likely, insurmountable by most individuals.  <a href="https://facebook.github.io/react-native/docs/components-and-apis.html#components-and-apis" alt="React Native user interface javascript library which Dallas uses">React Native</a> has unified the phone operating systems into a unique library which allows me to use React to simultaneously program both Android and IOS phone apps.  React is amazing!
      </span>
    )
  }
}



// WEBPACK FOOTER //
// ./src/config/custom-components/ReactNativeListItem.js